import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonUIModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { TruckRegistrationSummaryComponent } from './component/truck-registration-summary.component';
import { CommonTranslationModule } from '@sdbn/common';
import { MatCardModule as MatCardModule } from '@angular/material/card';



@NgModule({
  declarations: [
    TruckRegistrationSummaryComponent
  ],
  imports: [
    CommonModule,

    DictionaryModule,
    CommonTranslationModule,
    CommonUIModule,

    MatCardModule
  ]
})
export class TruckRegistrationSummaryModule { }
